import axios from "../http";
import baseConstant from "../constants/base-constant";

const request = {
    getWxOpenId(data = {}) {
        let url = baseConstant.REQ_WEIXIN_OPEN_ID_GET;
        return axios.request({
            url,
            data
        })
    },
    getMemberInfo(data = {}) {
        let url = baseConstant.REQ_MEMBER_INFO_GET;
        return axios.request({
            url,
            data
        })
    },

    doOrderPay(data = {}) {
        let url = baseConstant.REQ_ORDER_PAY;
        return axios.request({
            url,
            data
        });
    }
};

export default request;
